import { LicenseFratSubFormWebComponent } from './component/LicenseFratSubFormWebComponent';
import { WEB_COMPONENT_LICENSE_FRAT_SUBFORM } from '../../webcomponents.constants';

export { LicenseFratSubFormWebComponent };

window.customElements.define(WEB_COMPONENT_LICENSE_FRAT_SUBFORM, LicenseFratSubFormWebComponent);
